import React, { useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import Router from "next/router";

export default function Home() {
  useEffect(() => {
    window.location = "https://www.vvenues.com";
  });
  return (
    <div className="container">
      <Head>
        <title>Virtual Events</title>
        {/* <link rel="icon" href="/favicon.ico" /> */}
      </Head>
    </div>
  );
}
